<template>
    <div class="TopicsTopEntrance">
        <div class="TopicsTopEntrance-header">
            <div>跑区详情</div>
            <div>
                <el-button type="primary" @click="handleSubmit">保存</el-button>
                <el-button type="primary" @click="$router.go(-1)">返回</el-button>
            </div>
        </div>
        <el-form label-width="80px" :inline="true" :model="queryForm">
            <el-form-item label="跑区名称">
                <el-input v-model="queryForm.name" />
            </el-form-item>
            <el-form-item label="涉及围栏">
                <el-select v-model="queryForm.fenceIds" placeholder="请选择" style="width: 200px" multiple
                    @change="bindFenceChange">
                    <el-option v-for="item in fenceOption" :value="item.id" :label="item.name" :key="item.id"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div style="flex: 1;" id="map"></div>
    </div>
</template>

<script>
import { baiduToAmap, batchBaiduToAmap } from '../../../../common/mapUtils.js';
import AMapLoader from '@amap/amap-jsapi-loader';

export default {
    data() {
        return {
            queryForm: {
                name: '',
                fenceIds: []
            },
            fenceOption: [],
            geoFenceDTOS: [],
            map: null,
            styleOptions: {
                strokeColor: "#0398FF",    // 边线颜色。
                fillColor: "#0398FF",      // 填充颜色。当参数为空时，圆形将没有填充效果。
                strokeWeight: 3,       // 边线的宽度，以像素为单位。
                strokeOpacity: 1,	   // 边线透明度，取值范围0 - 1。
                fillOpacity: 0.2,      // 填充的透明度，取值范围0 - 1。
                strokeStyle: 'solid' // 边线的样式，solid或dashed。
            },
            fenceIds: [],
            ply: []
        }
    },
    mounted() {
        this.getRunarea()
    },
    methods: {
        async getRunarea() {
            try {
                const geoResult = await this.$http({
                    method: 'GET',
                    url: this.$util.domain + '/adminapi/v1/campus/geoFence/list',
                    params: {
                        unid: this.$route.query.unid
                    }
                })
                if (geoResult.body.error === 10000 && geoResult.body.data && geoResult.body.data.length) {
                    this.fenceOption = geoResult.body.data
                } else {
                    this.fenceOption = []
                    this.$util.errorMsg(res.body.message);
                    return
                }
                if (!this.$route.query.id) {
                    return
                }
                const runResult = await this.$http({
                    method: 'GET',
                    url: this.$util.domain + '/adminapi/v1/campus/runArea/detail',
                    params: {
                        id: this.$route.query.id
                    }
                })
                if (runResult.body.error === 10000 && runResult.body.data && JSON.stringify(runResult.body.data) !== '{}') {
                    this.queryForm.name = runResult.body.data.name
                    this.queryForm.fenceIds = runResult.body.data.fenceIds || []
                    if (runResult.body.data.geoFenceDTOS && runResult.body.data.geoFenceDTOS.length) {
                        this.geoFenceDTOS = runResult.body.data.geoFenceDTOS[0].points
                    }
                    // 确保在下一个事件循环中初始化地图，让DOM元素完全渲染
                    this.$nextTick(() => {
                        this.drawingMyMap()
                    })
                } else {
                    this.$util.errorMsg(runResult.body.message);
                }
            } catch (error) {

            }
        },
        bindFenceChange(value) {
            let result = []
            if (this.fenceIds.length <= value.length) {
                result = value.filter(item => {
                    return this.fenceIds.indexOf(item) === -1
                })
                result.forEach((item) => {
                    this.$http({
                        method: 'GET',
                        url: this.$util.domain + '/adminapi/v1/campus/geoFence/detail',
                        params: {
                            id: item
                        }
                    }).then(res => {
                            if (res.body.data && JSON.stringify(res.body.data) !== '{}' && res.body.data.points && res.body.data.points.length) {
                                // 确保map对象已初始化
                                if (!this.map) {
                                    console.error('地图对象未初始化');
                                    return;
                                }
                                
                                // 使用AMapLoader确保AMap已加载
                                AMapLoader.load({
                                    key: "d92371543c53fdaa3a019886ebaa015a",
                                    version: "2.0",
                                    plugins: []
                                }).then((AMap) => {
                                    // 将百度地图坐标转换为高德地图坐标
                                    const coord = baiduToAmap(res.body.data.points[0].glon, res.body.data.points[0].glat);
                                    this.map.setCenter([coord.lng, coord.lat]);
                                    this.map.setZoom(15);
                                    
                                    // 转换所有围栏点坐标
                                    const amapPoints = res.body.data.points.map(point => {
                                        const coord = baiduToAmap(point.glon, point.glat);
                                        return [coord.lng, coord.lat];
                                    });
                                    
                                    let polygon = new AMap.Polygon({
                                        path: amapPoints,
                                        strokeColor: this.styleOptions.strokeColor,
                                        strokeWeight: this.styleOptions.strokeWeight,
                                        strokeOpacity: this.styleOptions.strokeOpacity,
                                        fillColor: this.styleOptions.fillColor,
                                        fillOpacity: this.styleOptions.fillOpacity,
                                        strokeStyle: this.styleOptions.strokeStyle
                                    });
                                    polygon.id = item;
                                    this.map.add(polygon);
                                }).catch(e => {
                                    console.error('地图API加载失败:', e);
                                });
                            }
                        })
                })
            } else {
                result = this.fenceIds.find(item => {
                    return value.indexOf(item) === -1
                })
                // 获取所有覆盖物并移除指定ID的多边形
                if (this.map) {
                    this.map.getAllOverlays().forEach(overlay => {
                        if (overlay.id === result) {
                            this.map.remove(overlay);
                        }
                    });
                }
            }
            this.fenceIds = value
        },
        drawingMyMap() {
            // 使用AMapLoader.load方式加载高德地图
            AMapLoader.load({
                key: "d92371543c53fdaa3a019886ebaa015a", // 使用项目中的高德地图Key
                version: "2.0", // 指定要加载的 JS API 的版本
                plugins: ["AMap.ToolBar", "AMap.Scale"] // 需要使用的插件列表
            }).then((AMap) => {
                let map = new AMap.Map("map", {
                    zoom: 15,
                    center: [116.404, 39.915]
                });
                this.map = map;
                
                // 如果有围栏数据，设置地图中心点
                if (this.geoFenceDTOS && this.geoFenceDTOS.length) {
                    // 将百度坐标转换为高德坐标
                    const coord = baiduToAmap(this.geoFenceDTOS[0].lon, this.geoFenceDTOS[0].lat);
                    map.setCenter([coord.lng, coord.lat]);
                }
            }).catch(e => {
                console.error('地图加载失败:', e);
                this.$util.errorMsg('地图加载失败，请刷新页面重试');
            });
        },
        handleSubmit() {
            this.$confirm('修改当前数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http({
                    method: 'POST',
                    url: this.$util.domain + '/adminapi/v1/campus/runArea/saveOrEdit',
                    body: JSON.stringify({
                        ...this.$route.query,
                        ...this.queryForm
                    })
                }).then(res => {
                    if (res.body.error === 10000) {
                        this.$util.successMsg('操作成功');
                        this.$router.go(-1)
                    } else {
                        this.$util.errorMsg(res.body.message);
                    }
                }).catch(() => {
                    this.$util.errorMsg('服务器内部错误');
                })
            })
        }
    }
}
</script>


<style scoped>
.TopicsTopEntrance {
    display: flex;
    flex-direction: column;
}

.TopicsTopEntrance-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #eee;
    font-size: 16px;
    padding: 0 10px 0 30px;
    margin: 20px 0;
}

.TopicsTopEntrance-main {
    padding: 0 10px;
}
</style>


// WEBPACK FOOTER //
// detail.vue?2376a046